import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What are the age requirements?',
  answer: 'Storm has programs for ages 3 and up. Mini Troopers is for ages 3-5, Kids Taekwondo is for ages 6 and up, and we also offer Adult Classes and Family Classes so the whole family can train together.'
}, {
  question: 'What is the cost?',
  answer: 'Sign up for a FREE one-week trial — then we can go over enrollment options face-to-face. We also offer a full month trial for $99 that includes a uniform.'
}, {
  question: 'What is the schedule?',
  answer: "We offer flexible class schedules to accommodate different families' needs. Mini Troopers run 4:30-5:00 PM Mon-Fri, Storm Troopers (ages 6+) run 5:00-6:00 PM and 6:00-7:00 PM Mon-Fri. Contact us for current class times."
}, {
  question: 'Do you offer trial classes?',
  answer: 'Yes — we offer trial classes for new students so you can experience our coaching and curriculum before committing. Contact us or fill out the sign-up form to schedule a trial class for your child.'
}, {
  question: 'What are the benefits?',
  answer: 'Our programs teach real martial arts skills while also building character, discipline, self-confidence, focus, fitness, and resilience. Your child will gain valuable life skills through our training.'
}];
export function ProgramsFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2872" />;
}